export enum TimeIntervalTypeEnum {
    DayDescription = 'Day',
    Day = 1,
    WeekDescription = 'Week',
    Week = 2,
    MonthDescription = 'Month',
    Month = 3,
}
